export const Countries = [
  {
    description: "Nigeria",
    value: "NG",
    continent: "Africa",
    filename: "nigeria"
  },
  {
    description: "Afghanistan",
    value: "AF",
    continent: "Asia",
    filename: "afghanistan"
  },
  {
    description: "Åland Islands",
    continent: "Europe",
    value: "AX"
  },
  {
    description: "Albania",
    value: "AL",
    continent: "Europe",
    filename: "albania"
  },
  {
    description: "Algeria",
    value: "DZ",
    continent: "Africa",
    filename: "algeria"
  },
  {
    description: "American Samoa",
    value: "AS",
    continent: "Oceania"
  },
  {
    description: "Andorra",
    value: "AD",
    continent: "Europe",
    filename: "andorra"
  },
  {
    description: "Angola",
    value: "AO",
    continent: "Africa",
    filename: "angola"
  },
  {
    description: "Anguilla",
    value: "AI",
    continent: "North America"
  },
  {
    description: "Antarctica",
    continent: "Antarctica",
    value: "AQ"
  },
  {
    description: "Antigua and Barbuda",
    value: "AG",
    continent: "North America",
    filename: "antigua-and-barbuda"
  },
  {
    description: "Argentina",
    value: "AR",
    continent: "South America",
    filename: "argentina"
  },
  {
    description: "Armenia",
    value: "AM",
    continent: "Europe",
    filename: "armenia"
  },
  {
    description: "Aruba",
    value: "AW",
    continent: "Europe"
  },
  {
    description: "Australia",
    value: "AU",
    continent: "Oceania",
    filename: "australia"
  },
  {
    description: "Austria",
    value: "AT",
    continent: "Europe",
    filename: "austria"
  },
  {
    description: "Azerbaijan",
    value: "AZ",
    continent: "Europe",
    filename: "azerbaijan"
  },
  {
    description: "Bahamas",
    value: "BS",
    continent: "North America",
    filename: "bahamas"
  },
  {
    description: "Bahrain",
    value: "BH",
    continent: "Asia",
    filename: "bahrain"
  },
  {
    description: "Bangladesh",
    value: "BD",
    continent: "Asia",
    filename: "bangladesh"
  },
  {
    description: "Barbados",
    value: "BB",
    continent: "North America",
    filename: "barbados"
  },
  {
    description: "Belarus",
    value: "BY",
    continent: "Europe",
    filename: "belarus"
  },
  {
    description: "Belgium",
    value: "BE",
    continent: "Europe",
    filename: "belgium"
  },
  {
    description: "Belize",
    value: "BZ",
    continent: "North America",
    filename: "belize"
  },
  {
    description: "Benin",
    value: "BJ",
    continent: "Africa",
    filename: "benin"
  },
  {
    description: "Bermuda",
    value: "BM",
    continent: "North America"
  },
  {
    description: "Bhutan",
    value: "BT",
    continent: "Asia",
    filename: "bhutan"
  },
  {
    description: "Bolivia",
    value: "BO",
    continent: "South America",
    filename: "bolivia"
  },
  {
    description: "Bosnia and Herzegovina",
    value: "BA",
    continent: "Europe",
    filename: "bosnia-and-herzegovina"
  },
  {
    description: "Botswana",
    value: "BW",
    continent: "Africa",
    filename: "botswana"
  },
  {
    description: "Bouvet Island",
    continent: "Antarctica",
    value: "BV"
  },
  {
    description: "Brazil",
    value: "BR",
    continent: "South America",
    filename: "brazil"
  },
  {
    description: "British Indian Ocean Territory",
    continent: "Africa",
    value: "IO"
  },
  {
    description: "Brunei Darussalam",
    value: "BN",
    continent: "Asia",
    filename: "brunei-darussalam"
  },
  {
    description: "Bulgaria",
    value: "BG",
    continent: "Europe",
    filename: "bulgaria"
  },
  {
    description: "Burkina Faso",
    value: "BF",
    continent: "Africa",
    filename: "burkina-faso"
  },
  {
    description: "Burundi",
    value: "BI",
    continent: "Africa",
    filename: "burundi"
  },
  {
    description: "Cambodia",
    value: "KH",
    continent: "Asia",
    filename: "cambodia"
  },
  {
    description: "Cameroon",
    value: "CM",
    continent: "Africa",
    filename: "cameroon"
  },
  {
    description: "Canada",
    value: "CA",
    continent: "North America",
    filename: "canada"
  },
  {
    description: "Cape Verde",
    value: "CV",
    continent: "Africa",
    filename: "cape-verde"
  },
  {
    description: "Cayman Islands",
    value: "KY",
    continent: "North America"
  },
  {
    description: "Central African Republic",
    value: "CF",
    continent: "Africa",
    filename: "central-african-republic"
  },
  {
    description: "Chad",
    value: "TD",
    continent: "Africa",
    filename: "chad"
  },
  {
    description: "Chile",
    value: "CL",
    continent: "South America",
    filename: "chile"
  },
  {
    description: "China",
    value: "CN",
    continent: "Asia",
    filename: "china"
  },
  {
    description: "Christmas Island",
    value: "CX",
    continent: "Oceania"
  },
  {
    description: "Cocos (Keeling) Islands",
    value: "CC",
    continent: "Oceania"
  },
  {
    description: "Colombia",
    value: "CO",
    continent: "South America",
    filename: "colombia"
  },
  {
    description: "Comoros",
    value: "KM",
    continent: "Africa",
    filename: "comoros"
  },
  {
    description: "Congo",
    value: "CG",
    continent: "Africa",
    filename: "congo"
  },
  {
    description: "Congo, The Democratic Republic of the",
    value: "CD",
    continent: "Africa",
    filename: "congo-the-democratic-republic-of-the"
  },
  {
    description: "Cook Islands",
    continent: "Oceania",
    value: "CK"
  },
  {
    description: "Costa Rica",
    value: "CR",
    continent: "North America",
    filename: "costa-rica"
  },
  {
    description: "Côte d'Ivoire, Republic of",
    value: "CI",
    continent: "Africa",
    filename: "cote-d-ivoire-republic-of"
  },
  {
    description: "Croatia",
    value: "HR",
    continent: "Europe",
    filename: "croatia"
  },
  {
    description: "Cuba",
    value: "CU",
    continent: "North America",
    filename: "cuba"
  },
  {
    description: "Curaçao",
    value: "CW",
    continent: "Europe"
  },
  {
    description: "Cyprus",
    value: "CY",
    continent: "Europe",
    filename: "cyprus"
  },
  {
    description: "Czech Republic",
    value: "CZ",
    continent: "Europe",
    filename: "czech-republic"
  },
  {
    description: "Denmark",
    value: "DK",
    continent: "Europe",
    filename: "denmark"
  },
  {
    description: "Djibouti",
    value: "DJ",
    continent: "Africa",
    filename: "djibouti"
  },
  {
    description: "Dominica",
    value: "DM",
    continent: "North America",
    filename: "dominica"
  },
  {
    description: "Dominican Republic",
    value: "DO",
    continent: "North America",
    filename: "dominican-republic"
  },
  {
    description: "Ecuador",
    value: "EC",
    continent: "South America",
    filename: "ecuador"
  },
  {
    description: "Egypt",
    value: "EG",
    continent: "Africa",
    filename: "egypt"
  },
  {
    description: "El Salvador",
    value: "SV",
    continent: "North America",
    filename: "el-salvador"
  },
  {
    description: "Equatorial Guinea",
    value: "GQ",
    continent: "Africa",
    filename: "equatorial-guinea"
  },
  {
    description: "Eritrea",
    value: "ER",
    continent: "Africa",
    filename: "eritrea"
  },
  {
    description: "Estonia",
    value: "EE",
    continent: "Europe",
    filename: "estonia"
  },
  {
    description: "Ethiopia",
    value: "ET",
    continent: "Africa",
    filename: "ethiopia"
  },
  {
    description: "Falkland Islands (Malvinas)",
    value: "FK",
    continent: "South America"
  },
  {
    description: "Faroe Islands",
    continent: "Europe",
    value: "FO"
  },
  {
    description: "Fiji",
    value: "FJ",
    continent: "Oceania",
    filename: "fiji"
  },
  {
    description: "Finland",
    value: "FI",
    continent: "Europe",
    filename: "finland"
  },
  {
    description: "France",
    value: "FR",
    continent: "Europe",
    filename: "france"
  },
  {
    description: "French Guiana",
    value: "GF",
    continent: "South America"
  },
  {
    description: "French Polynesia",
    value: "PF",
    continent: "Oceania"
  },
  {
    description: "French Southern Territories",
    continent: "Antarctica",
    value: "TF"
  },
  {
    description: "Gabon",
    value: "GA",
    continent: "Africa",
    filename: "gabon"
  },
  {
    description: "Gambia",
    value: "GM",
    continent: "Africa",
    filename: "gambia"
  },
  {
    description: "Georgia",
    value: "GE",
    continent: "Europe",
    filename: "georgia"
  },
  {
    description: "Germany",
    value: "DE",
    continent: "Europe",
    filename: "germany"
  },
  {
    description: "Ghana",
    value: "GH",
    continent: "Africa",
    filename: "ghana"
  },
  {
    description: "Gibraltar",
    continent: "Europe",
    value: "GI"
  },
  {
    description: "Greece",
    value: "GR",
    continent: "Europe",
    filename: "greece"
  },
  {
    description: "Greenland",
    value: "GL",
    continent: "North America",
    filename: "greenland"
  },
  {
    description: "Grenada",
    value: "GD",
    continent: "North America",
    filename: "grenada"
  },
  {
    description: "Guadeloupe",
    value: "GP",
    continent: "North America"
  },
  {
    description: "Guam",
    value: "GU",
    continent: "Oceania"
  },
  {
    description: "Guatemala",
    value: "GT",
    continent: "North America",
    filename: "guatemala"
  },
  {
    description: "Guernsey",
    continent: "Europe",
    value: "GG"
  },
  {
    description: "Guinea",
    value: "GN",
    continent: "Africa",
    filename: "guinea"
  },
  {
    description: "Guinea-Bissau",
    value: "GW",
    continent: "Africa",
    filename: "guinea-bissau"
  },
  {
    description: "Guyana",
    value: "GY",
    continent: "South America",
    filename: "guyana"
  },
  {
    description: "Haiti",
    value: "HT",
    continent: "North America",
    filename: "haiti"
  },
  {
    description: "Heard Island and Mcdonald Islands",
    continent: "Oceania",
    value: "HM"
  },
  {
    description: "Holy See (Vatican City State)",
    value: "VA",
    continent: "Europe"
  },
  {
    description: "Honduras",
    value: "HN",
    continent: "North America",
    filename: "honduras"
  },
  {
    description: "Hong Kong",
    value: "HK",
    continent: "Asia",
    filename: "hong-kong"
  },
  {
    description: "Hungary",
    value: "HU",
    continent: "Europe",
    filename: "hungary"
  },
  {
    description: "Iceland",
    value: "IS",
    continent: "Europe",
    filename: "iceland"
  },
  {
    description: "India",
    value: "IN",
    continent: "Asia",
    filename: "india"
  },
  {
    description: "Indonesia",
    value: "ID",
    continent: "Asia",
    filename: "indonesia"
  },
  {
    description: "Iran, Islamic Republic Of",
    value: "IR",
    continent: "Asia",
    filename: "iran-islamic-republic-of"
  },
  {
    description: "Iraq",
    value: "IQ",
    continent: "Asia",
    filename: "iraq"
  },
  {
    description: "Ireland",
    value: "IE",
    continent: "Europe",
    filename: "ireland"
  },
  {
    description: "Isle of Man",
    continent: "Europe",
    value: "IM"
  },
  {
    description: "Israel",
    value: "IL",
    continent: "Asia",
    filename: "israel"
  },
  {
    description: "Italy",
    value: "IT",
    continent: "Europe",
    filename: "italy"
  },
  {
    description: "Jamaica",
    value: "JM",
    continent: "North America",
    filename: "jamaica"
  },
  {
    description: "Japan",
    value: "JP",
    continent: "Asia",
    filename: "japan"
  },
  {
    description: "Jersey",
    continent: "Europe",
    value: "JE"
  },
  {
    description: "Jordan",
    value: "JO",
    continent: "Asia",
    filename: "jordan"
  },
  {
    description: "Kazakhstan",
    value: "KZ",
    continent: "Europe",
    filename: "kazakhstan"
  },
  {
    description: "Kenya",
    value: "KE",
    continent: "Africa",
    filename: "kenya"
  },
  {
    description: "Kiribati",
    value: "KI",
    continent: "Oceania",
    filename: "kiribati"
  },
  {
    description: "Korea, Democratic People's Republic of",
    value: "KP",
    continent: "Asia",
    filename: "korea-democratic-people-s-republic-of"
  },
  {
    description: "Korea, Republic of",
    value: "KR",
    continent: "Asia",
    filename: "korea-republic-of"
  },
  {
    description: "Kuwait",
    value: "KW",
    continent: "Asia",
    filename: "kuwait"
  },
  {
    description: "Kyrgyzstan",
    value: "KG",
    continent: "Asia",
    filename: "kyrgyzstan"
  },
  {
    description: "Lao People's Democratic Republic",
    value: "LA",
    continent: "Asia",
    filename: "lao-people-s-democratic-republic"
  },
  {
    description: "Latvia",
    value: "LV",
    continent: "Europe",
    filename: "latvia"
  },
  {
    description: "Lebanon",
    value: "LB",
    continent: "Asia",
    filename: "lebanon"
  },
  {
    description: "Lesotho",
    value: "LS",
    continent: "Africa",
    filename: "lesotho"
  },
  {
    description: "Liberia",
    value: "LR",
    continent: "Africa",
    filename: "liberia"
  },
  {
    description: "Libyan Arab Jamahiriya",
    value: "LY",
    continent: "Africa",
    filename: "libyan-arab-jamahiriya"
  },
  {
    description: "Liechtenstein",
    value: "LI",
    continent: "Europe",
    filename: "liechtenstein"
  },
  {
    description: "Lithuania",
    value: "LT",
    continent: "Europe",
    filename: "lithuania"
  },
  {
    description: "Luxembourg",
    value: "LU",
    continent: "Europe",
    filename: "luxembourg"
  },
  {
    description: "Macao",
    value: "MO",
    continent: "Asia"
  },
  {
    description: "Macedonia, The Former Yugoslav Republic of",
    value: "MK",
    continent: "Europe",
    filename: "macedonia-the-former-yugoslav-republic-of"
  },
  {
    description: "Madagascar",
    value: "MG",
    continent: "Africa",
    filename: "madagascar"
  },
  {
    description: "Malawi",
    value: "MW",
    continent: "Africa",
    filename: "malawi"
  },
  {
    description: "Malaysia",
    value: "MY",
    continent: "Asia",
    filename: "malaysia"
  },
  {
    description: "Maldives",
    value: "MV",
    continent: "Asia",
    filename: "maldives"
  },
  {
    description: "Mali",
    value: "ML",
    continent: "Africa",
    filename: "mali"
  },
  {
    description: "Malta",
    value: "MT",
    continent: "Europe",
    filename: "malta"
  },
  {
    description: "Marshall Islands",
    value: "MH",
    continent: "Oceania",
    filename: "marshall-islands"
  },
  {
    description: "Martinique",
    value: "MQ",
    continent: "North America"
  },
  {
    description: "Mauritania",
    value: "MR",
    continent: "Africa",
    filename: "mauritania"
  },
  {
    description: "Mauritius",
    value: "MU",
    continent: "Africa",
    filename: "mauritius"
  },
  {
    description: "Mayotte",
    value: "YT",
    continent: "Africa"
  },
  {
    description: "Mexico",
    value: "MX",
    continent: "North America",
    filename: "mexico"
  },
  {
    description: "Micronesia, Federated States of",
    value: "FM",
    continent: "Oceania",
    filename: "micronesia-federated-states-of"
  },
  {
    description: "Moldova, Republic of",
    value: "MD",
    continent: "Europe",
    filename: "moldova-republic-of"
  },
  {
    description: "Monaco",
    value: "MC",
    continent: "Europe",
    filename: "monaco"
  },
  {
    description: "Mongolia",
    value: "MN",
    continent: "Asia",
    filename: "mongolia"
  },
  {
    description: "Montenegro",
    value: "ME",
    continent: "Europe",
    filename: "montenegro"
  },
  {
    description: "Montserrat",
    value: "MS",
    continent: "North America"
  },
  {
    description: "Morocco",
    value: "MA",
    continent: "Africa",
    filename: "morocco"
  },
  {
    description: "Mozambique",
    value: "MZ",
    continent: "Africa",
    filename: "mozambique"
  },
  {
    description: "Myanmar",
    value: "MM",
    continent: "Asia",
    filename: "myanmar"
  },
  {
    description: "Namibia",
    value: "NA",
    continent: "Africa",
    filename: "namibia"
  },
  {
    description: "Nauru",
    value: "NR",
    continent: "Oceania",
    filename: "nauru"
  },
  {
    description: "Nepal",
    value: "NP",
    continent: "Asia",
    filename: "nepal"
  },
  {
    description: "Netherlands",
    value: "NL",
    continent: "Europe",
    filename: "netherlands"
  },
  {
    description: "Netherlands Antilles",
    value: "AN",
    continent: "Europe"
  },
  {
    description: "New Caledonia",
    value: "NC",
    continent: "Oceania"
  },
  {
    description: "New Zealand",
    value: "NZ",
    continent: "Oceania",
    filename: "new-zealand"
  },
  {
    description: "Nicaragua",
    value: "NI",
    continent: "North America",
    filename: "nicaragua"
  },
  {
    description: "Niger",
    value: "NE",
    continent: "Africa",
    filename: "niger"
  },
  {
    description: "Niue",
    continent: "Oceania",
    value: "NU"
  },
  {
    description: "Norfolk Island",
    value: "NF",
    continent: "Oceania"
  },
  {
    description: "Northern Mariana Islands",
    continent: "Oceania",
    value: "MP"
  },
  {
    description: "Norway",
    value: "NO",
    continent: "Europe",
    filename: "norway"
  },
  {
    description: "Oman",
    value: "OM",
    continent: "Asia",
    filename: "oman"
  },
  {
    description: "Pakistan",
    value: "PK",
    continent: "Asia",
    filename: "pakistan"
  },
  {
    description: "Palau",
    value: "PW",
    continent: "Oceania",
    filename: "palau"
  },
  {
    description: "Palestinian Territory, Occupied",
    value: "PS",
    continent: "Asia",
    filename: "palestinian-territory-occupied"
  },
  {
    description: "Panama",
    value: "PA",
    continent: "North America",
    filename: "panama"
  },
  {
    description: "Papua New Guinea",
    value: "PG",
    continent: "Oceania",
    filename: "papua-new-guinea"
  },
  {
    description: "Paraguay",
    value: "PY",
    continent: "South America",
    filename: "paraguay"
  },
  {
    description: "Peru",
    value: "PE",
    continent: "South America",
    filename: "peru"
  },
  {
    description: "Philippines",
    value: "PH",
    continent: "Asia",
    filename: "philippines"
  },
  {
    description: "Pitcairn",
    continent: "Oceania",
    value: "PN"
  },
  {
    description: "Poland",
    value: "PL",
    continent: "Europe",
    filename: "poland"
  },
  {
    description: "Portugal",
    value: "PT",
    continent: "Europe",
    filename: "portugal"
  },
  {
    description: "Puerto Rico",
    value: "PR",
    continent: "North America"
  },
  {
    description: "Qatar",
    value: "QA",
    continent: "Asia",
    filename: "qatar"
  },
  {
    description: "Réunion",
    value: "RE",
    continent: "Africa"
  },
  {
    description: "Romania",
    value: "RO",
    continent: "Europe",
    filename: "romania"
  },
  {
    description: "Russian Federation",
    value: "RU",
    continent: "Europe",
    filename: "russian-federation"
  },
  {
    description: "Rwanda",
    value: "RW",
    continent: "Africa",
    filename: "rwanda"
  },
  {
    description: "Saint Helena, Ascension and Tristan da Cunha",
    value: "SH",
    continent: "Africa",
    filename: "saint-helena-ascension-and-tristan-da-cunha"
  },
  {
    description: "Saint Kitts and Nevis",
    value: "KN",
    continent: "North America",
    filename: "saint-kitts-and-nevis"
  },
  {
    description: "Saint Lucia",
    value: "LC",
    continent: "North America",
    filename: "saint-lucia"
  },
  {
    description: "Saint Pierre and Miquelon",
    value: "PM",
    continent: "North America"
  },
  {
    description: "Saint Vincent and the Grenadines",
    value: "VC",
    continent: "North America",
    filename: "saint-vincent-and-the-grenadines"
  },
  {
    description: "Samoa",
    value: "WS",
    continent: "Oceania",
    filename: "samoa"
  },
  {
    description: "San Marino",
    value: "SM",
    continent: "Europe",
    filename: "san-marino"
  },
  {
    description: "São Tomé and Príncipe",
    value: "ST",
    continent: "Africa",
    filename: "sao-tome-and-principe"
  },
  {
    description: "Saudi Arabia",
    value: "SA",
    continent: "Asia",
    filename: "saudi-arabia"
  },
  {
    description: "Senegal",
    value: "SN",
    continent: "Africa",
    filename: "senegal"
  },
  {
    description: "Serbia",
    value: "RS",
    continent: "Europe",
    filename: "serbia"
  },
  {
    description: "Seychelles",
    value: "SC",
    continent: "Africa",
    filename: "seychelles"
  },
  {
    description: "Sierra Leone",
    value: "SL",
    continent: "Africa",
    filename: "sierra-leone"
  },
  {
    description: "Singapore",
    value: "SG",
    continent: "Asia",
    filename: "singapore"
  },
  {
    description: "Sint Maarten",
    value: "SX",
    continent: "Europe"
  },
  {
    description: "Slovakia",
    value: "SK",
    continent: "Europe",
    filename: "slovakia"
  },
  {
    description: "Slovenia",
    value: "SI",
    continent: "Europe",
    filename: "slovenia"
  },
  {
    description: "Solomon Islands",
    value: "SB",
    continent: "Oceania",
    filename: "solomon-islands"
  },
  {
    description: "Somalia",
    value: "SO",
    continent: "Africa",
    filename: "somalia"
  },
  {
    description: "South Africa",
    value: "ZA",
    continent: "Africa",
    filename: "south-africa"
  },
  {
    description: "South Georgia and the South Sandwich Islands",
    value: "GS",
    continent: "South America"
  },
  {
    description: "South Sudan",
    value: "SS",
    continent: "Africa",
    filename: "south-sudan"
  },
  {
    description: "Spain",
    value: "ES",
    continent: "Europe",
    filename: "spain"
  },
  {
    description: "Sri Lanka",
    value: "LK",
    continent: "Asia",
    filename: "sri-lanka"
  },
  {
    description: "Sudan",
    value: "SD",
    continent: "Africa",
    filename: "sudan"
  },
  {
    description: "Suriname",
    value: "SR",
    continent: "South America",
    filename: "suriname"
  },
  {
    description: "Svalbard and Jan Mayen",
    continent: "Europe",
    value: "SJ"
  },
  {
    description: "Swaziland",
    value: "SZ",
    continent: "Africa",
    filename: "swaziland"
  },
  {
    description: "Sweden",
    value: "SE",
    continent: "Europe",
    filename: "sweden"
  },
  {
    description: "Switzerland",
    value: "CH",
    continent: "Europe",
    filename: "switzerland"
  },
  {
    description: "Syrian Arab Republic",
    value: "SY",
    continent: "Asia",
    filename: "syrian-arab-republic"
  },
  {
    description: "Taiwan, Province of China",
    value: "TW",
    continent: "Asia",
    filename: "taiwan-province-of-china"
  },
  {
    description: "Tajikistan",
    value: "TJ",
    continent: "Asia",
    filename: "tajikistan"
  },
  {
    description: "Tanzania, United Republic of",
    value: "TZ",
    continent: "Africa",
    filename: "tanzania-united-republic-of"
  },
  {
    description: "Thailand",
    value: "TH",
    continent: "Asia",
    filename: "thailand"
  },
  {
    description: "Timor-Leste",
    value: "TL",
    continent: "Oceania",
    filename: "timor-leste"
  },
  {
    description: "Togo",
    value: "TG",
    continent: "Africa",
    filename: "togo"
  },
  {
    description: "Tokelau",
    continent: "Oceania",
    value: "TK"
  },
  {
    description: "Tonga",
    value: "TO",
    continent: "Oceania",
    filename: "tonga"
  },
  {
    description: "Trinidad and Tobago",
    value: "TT",
    continent: "North America",
    filename: "trinidad-and-tobago"
  },
  {
    description: "Tunisia",
    value: "TN",
    continent: "Africa",
    filename: "tunisia"
  },
  {
    description: "Turkey",
    value: "TR",
    continent: "Europe",
    filename: "turkey"
  },
  {
    description: "Turkmenistan",
    value: "TM",
    continent: "Asia",
    filename: "turkmenistan"
  },
  {
    description: "Turks and Caicos Islands",
    value: "TC",
    continent: "North America"
  },
  {
    description: "Tuvalu",
    value: "TV",
    continent: "Oceania",
    filename: "tuvalu"
  },
  {
    description: "Uganda",
    value: "UG",
    continent: "Africa",
    filename: "uganda"
  },
  {
    description: "Ukraine",
    value: "UA",
    continent: "Europe",
    filename: "ukraine"
  },
  {
    description: "United Arab Emirates",
    value: "AE",
    continent: "Asia",
    filename: "united-arab-emirates"
  },
  {
    description: "United Kingdom",
    value: "GB",
    continent: "Europe",
    filename: "united-kingdom"
  },
  {
    description: "United States",
    value: "US",
    continent: "North America",
    filename: "united-states"
  },
  {
    description: "United States Minor Outlying Islands",
    value: "UM",
    continent: "North America",
    filename: "united-states-minor-outlying-islands"
  },
  {
    description: "Uruguay",
    value: "UY",
    continent: "South America",
    filename: "uruguay"
  },
  {
    description: "Uzbekistan",
    value: "UZ",
    continent: "Asia",
    filename: "uzbekistan"
  },
  {
    description: "Vanuatu",
    value: "VU",
    continent: "Oceania",
    filename: "vanuatu"
  },
  {
    description: "Venezuela",
    value: "VE",
    continent: "South America",
    filename: "venezuela"
  },
  {
    description: "Viet Nam",
    value: "VN",
    continent: "Asia",
    filename: "viet-nam"
  },
  {
    description: "Virgin Islands, British",
    value: "VG",
    continent: "North America"
  },
  {
    description: "Virgin Islands, U.S.",
    value: "VI",
    continent: "North America"
  },
  {
    description: "Wallis and Futuna",
    continent: "Oceania",
    value: "WF"
  },
  {
    description: "Western Sahara",
    continent: "Africa",
    value: "EH"
  },
  {
    description: "Yemen",
    value: "YE",
    continent: "Asia",
    filename: "yemen"
  },
  {
    description: "Zambia",
    value: "ZM",
    continent: "Africa",
    filename: "zambia"
  },
  {
    description: "Zimbabwe",
    value: "ZW",
    continent: "Africa",
    filename: "zimbabwe"
  }
];



// WEBPACK FOOTER //
// ./src/configurations/discoverConfigs/countries.js